import { render, staticRenderFns } from "./leistungen-projektmanagement-1.vue?vue&type=template&id=3fc5d714&"
import script from "./leistungen-projektmanagement-1.vue?vue&type=script&lang=js&"
export * from "./leistungen-projektmanagement-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports